import { TripContext } from 'contexts'
import { useContext } from 'react'
import { LicensePlate, Mispick, Order, Stop, StopEquipment, TrailerTemperature } from 'services/types'
import { StopStatus } from './enums'
import { useLicensePlateService } from './useLicensePlateService'
import { useOrderService } from './useOrderService'

export const useStopService = () => {

    const { deleteOrders } = useOrderService()
    const { deleteLicensePlates } = useLicensePlateService()

    const tripContext = useContext(TripContext)

    const sortStops = (stops: Stop[]): Stop[] => {
        stops.sort((a: Stop, b: Stop): number => {
            if (a.appointmentTime == null) return -1
            else if (b.appointmentTime == null) return 1
            else return (a.appointmentTime < b.appointmentTime ?? new Date()) ? -1 : 1
        })
        return stops
    }

    const setTrailerTemp = (stop: Stop, noseTemp: TrailerTemperature, middleTemp: TrailerTemperature, tailTemp: TrailerTemperature): void => {
        stop.trailerTemperatures.nose = noseTemp
        stop.trailerTemperatures.middle = middleTemp
        stop.trailerTemperatures.tail = tailTemp
        tripContext.stops.put(stop)
    }

    const updateStopStatus = (stopId: number, status: StopStatus): void => {
        let stop: Stop | undefined = tripContext.stops.find(s => s.id === stopId)
        if (stop) {
            stop.stopStatus = status
            tripContext.stops.put(stop)
        }
    }

    const deleteStops = (stopIds: number[]): void => {
        const stopEquipment: StopEquipment[] = tripContext.stopEquipments.filter(equipment => stopIds.includes(equipment.stopId))
        const mispicks: Mispick[] = tripContext.mispicks.filter(mispick => stopIds.includes(mispick.stopId))
        const orders: Order[] = tripContext.orders.filter(order => stopIds.includes(order.stopId))
        const lps: LicensePlate[] = tripContext.licensePlates.filter(lp => stopIds.includes(lp.stopId))

        tripContext.stops.bulkRemove(stopIds),
        tripContext.stopEquipments.bulkRemove(stopEquipment.map(equipment => equipment.id)),
        tripContext.mispicks.bulkRemove(mispicks.map(mispick => mispick.id)),
        deleteOrders(orders.map(order => order.id)),
        deleteLicensePlates(lps.map(lp => lp.id))
    }

    return {
        setTrailerTemp: setTrailerTemp,
        updateStopStatus: updateStopStatus,
        deleteStops: deleteStops
    }

}